var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountPlusFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 11.6666C10.2757 11.6666 5.83398 12.7749 5.83398 14.9999V16.6666H19.1673V14.9999C19.1673 12.7749 14.7257 11.6666 12.5007 11.6666ZM5.00065 8.33325V5.83325H3.33398V8.33325H0.833984V9.99992H3.33398V12.4999H5.00065V9.99992H7.50065V8.33325M12.5007 9.99992C13.3847 9.99992 14.2326 9.64873 14.8577 9.02361C15.4828 8.39849 15.834 7.55064 15.834 6.66659C15.834 5.78253 15.4828 4.93468 14.8577 4.30956C14.2326 3.68444 13.3847 3.33325 12.5007 3.33325C11.6166 3.33325 10.7688 3.68444 10.1436 4.30956C9.51851 4.93468 9.16732 5.78253 9.16732 6.66659C9.16732 7.55064 9.51851 8.39849 10.1436 9.02361C10.7688 9.64873 11.6166 9.99992 12.5007 9.99992Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPlusFilled);
export default __webpack_public_path__ + "static/media/account_plus_filled.af6bfd9d91d1632fbaa1a5f38e152aae.svg";
export { ForwardRef as ReactComponent };